import React from "react";
import { Helmet } from "react-helmet-async";
import "./LegalPages.css";

function TermsConditions() {
  return (
    <div className="dor-legal-page">
      <Helmet>
        <title>Terms &amp; Conditions | DOR Dress On Rent</title>
        <meta
          name="description"
          content="Read the terms and conditions for using DOR Dress On Rent services, rentals, and website."
        />
        <link rel="canonical" href="https://www.dordressonrent.com/terms" />
      </Helmet>

      <div className="dor-legal-container">

        <h1>Terms & Conditions</h1>

        <p>
          Welcome to Dress On Rent (DOR). By accessing or using our website,
          services, or franchise partnership opportunities, you agree to
          comply with and be bound by the following terms and conditions.
        </p>

        <h2>1. Use of Website</h2>
        <p>
          The content on this website is provided for general information
          about our outfit rental services and partnership opportunities.
          You may not copy, reproduce, or distribute any content without
          written permission.
        </p>

        <h2>2. Partnership Information</h2>
        <p>
          All information related to franchise or partnership opportunities
          is provided for informational purposes only and may change
          without prior notice.
        </p>

        <h2>3. Intellectual Property</h2>
        <p>
          All branding, logos, content, and materials displayed on this
          website belong to Dress On Rent and may not be used without
          authorization.
        </p>

        <h2>4. Limitation of Liability</h2>
        <p>
          Dress On Rent shall not be responsible for any direct or
          indirect damages arising from the use of this website or
          reliance on its information.
        </p>

        <h2>5. Updates to Terms</h2>
        <p>
          We may update these terms from time to time. Continued use
          of the website indicates acceptance of the updated terms.
        </p>

        <h2>6. Contact</h2>
        <p>
          For any questions regarding these terms, please contact us
          through our official communication channels.
        </p>

      </div>

    </div>
  );
}

export default TermsConditions;